import * as XLSX from 'xlsx/dist/xlsx.full.min';

// 处理文件上传的函数
export async function getRowsCount(files : any []){
	let array = new Array(files.length)
	for(let i = 0; i < files.length; i ++){
		let file = files[i]
		array[i] = await reader(file)
	}
	console.log("getRowsCount", array);
	return array;
}

export async function getArrangeCount(files : any []){
	let array = new Array(files.length)
	for(let i = 0; i < files.length; i ++){
		let file = files[i]
		array[i] = await readerArrange(file)
	}
	console.log("getArrangeCount===", array);
	return array;
}

export async function getExcelJson(file: any){
	return new Promise((resolve, reject)=>{
		let rd = new FileReader()
		rd.onload = (e)=>{
			try{
				const data = new Uint8Array(e.target?.result as ArrayBuffer);
				const workbook = XLSX.read(data, { type: 'array' })
				const firstSheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[firstSheetName];
				const range = XLSX.utils.decode_range(worksheet['!ref']);
        		let columnCount = range.e.c + 1; // 列数 = 结束列索引 + 1
				// 转换为行数组格式（包含所有原始数据）
				const rawRows = XLSX.utils.sheet_to_json(worksheet, { 
					header: 1,    // 生成二维数组
					defval: "", // 空单元格填充为null
				  	raw: true     // 保留原始值（不进行格式转换）
				});
				// 过滤重复行
				// const uniqueData = removeDuplicates(rawRows);

				let result = rawRows.map((row: any) => row.slice(0, columnCount))
				      .filter(row => row.some((cell : any) => cell !== null));
				result = result.map(row => {
					const filteredRow = {};
					for (const key in row) {
						if (row[key] !== '') {
							filteredRow[key] = row[key];
						}
					}
					return filteredRow;
				});
				console.log('前两列数据：', result, columnCount);
				resolve(result)
			}catch(e){
				console.log('文件解析失败：', e);
				reject(e)
			}
		}
		rd.onerror = (e)=>{
			reject(e)
		}
		rd.readAsArrayBuffer(file)
	})
}

// 过滤重复行
const removeDuplicates = (data) => {
	const seen = new Set();
	return data.filter((row) => {
		const rowString = JSON.stringify(row); // 将行数据转换为字符串
		return seen.has(rowString) ? false : seen.add(rowString);
	});
};

export function reader(file: any){
	return new Promise((resolve, reject)=>{
		let rd = new FileReader()
		rd.readAsArrayBuffer(file)
		rd.onload = (e)=>{
			let data = XLSX.read(e.target.result, { type: 'array' }); 
			console.log("data", data.Sheets)
			let totalRows = 0;
			for(let key in data.Sheets){
				let sheet = data.Sheets[key]
				const range =  XLSX.utils.decode_range(sheet['!ref'])
				
				let actualRowCount = 0;
				for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
				  const cell = sheet[XLSX.utils.encode_cell({ r: rowNum, c: 0 })];
				  if (cell && cell.v) actualRowCount++;
				}
				totalRows += actualRowCount
			}
			resolve(totalRows)
		}
	})
}

export function readerArrange(file: any){
	console.log("readerArrange===", file)
	return new Promise((resolve, reject)=>{
		let rd = new FileReader()
		rd.readAsArrayBuffer(file)
		rd.onload = (e)=>{
			try{
				const data = new Uint8Array(e.target?.result as ArrayBuffer);
				const workbook = XLSX.read(data, { type: 'array' })
				const firstSheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[firstSheetName];
				// 转换为行数组格式（包含所有原始数据）
				const range = XLSX.utils.decode_range(worksheet['!ref']);
        		let columnCount = range.e.c + 1; // 列数 = 结束列索引 + 1
				console.log('列总数：', columnCount);
				resolve(columnCount)
			}catch(e){
				reject(e)
			}
		}
	})
}